import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useResponsiveFlags from "../hooks/useResponsiveFlags";


export default function HiresMyData({
  formData,
  updateFormData,
  errors,
  clearFieldError,
  disabled,
  tokens,
  bulkExpressionFile,
}) {
  const {isDesktop } = useResponsiveFlags();
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target;
    clearFieldError(name);
    if (value === "upload") {
      navigate("/uploadfile");
    } else {
      if (name === "fractionResultFile") {
        const [id, fileName] = value.split("|"); // Split the concatenated value
        updateFormData({ [name]: { id, value: fileName } }); // Update with object
      } else if (name === "bulkExpressionFile") {
        const [id, fileName] = value.split("|"); // Split the concatenated value
        updateFormData({ [name]: { id, value: fileName } });
      } else if (name === "token") {
        const [id, fileName] = value.split("|"); // Split the concatenated value
        updateFormData({ [name]: { id, value: fileName } });
      } else {
        updateFormData({ [name]: value });
      }
    }
  };
  const [fracResultFile, setFracResultFile] = useState([]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await fetch(
  //         `${process.env.REACT_APP_API_URL}/api/get-hires-token`,
  //         {
  //           method: "GET",
  //         credentials: "include",
  //           // headers: {
  //           //   Authorization: `Bearer ${localStorage.getItem("token")}`,
  //           // },
  //         }
  //       ); // Replace with your API endpoint
  //       const data = await response.json();
  //       setTokens(data.items); // Assuming the API returns an array of tokens

  //       const mixtureFile = await fetch(
  //         `${process.env.REACT_APP_API_URL}/api/get-mixture-file`,
  //         {method: "GET",
  //           credentials: "include",
  //           // headers: {
  //           //   Authorization: `Bearer ${localStorage.getItem("token")}`,
  //           // },
  //         }
  //       ); // Replace with your API endpoint
  //       const files = await mixtureFile.json();
  //       setBulkExpressionFile(files.items);

  //       const fracResultFile = await fetch(
  //         `${process.env.REACT_APP_API_URL}/api/get-bulkexpression-file`,
  //         {method: "GET",
  //           credentials: "include",
  //           // headers: {
  //           //   Authorization: `Bearer ${localStorage.getItem("token")}`,
  //           // },
  //         }
  //       ); // Replace with your API endpoint
  //       const fracFiles = await fracResultFile.json();
  //       setFracResultFile(fracFiles.items);
  //     } catch (error) {
  //       console.error("Error fetching data", error);
  //     }
  //   };

    // fetchData();
  // }, []);

  return (
    <>

        <div className="row">
 
          <div className="col-lg-3 mb-3">
          <p className="form-label">Configure Custom Input</p>
          </div>

   
          <div className="col-lg-6">

          <div className="form-group">
            <label className="menu-options label-spacing">Fraction Result File*</label>
            <select
              name="fractionResultFile"
              value={
                `${formData.fractionResultFile.id}`
                  ? `${formData.fractionResultFile.id}|${formData.fractionResultFile.value}`
                  : ""
              }
              onChange={handleChange}
              className="form-select"
              required
            >
              <option value="" disabled>
                Select...
              </option>
              {fracResultFile.map((file) => (
                <option key={file.id} value={`${file.id}|${file.name}`}>
                  {file.name}
                </option>
              ))}
              {/* Options */}
              <option value="upload">Go to upload page to upload file.</option>
            </select>
            {errors.fractionResultFile && (
              <p className="error-text">{errors.fractionResultFile}</p>
            )}
          </div>

          <div className="form-group">
            <label className="menu-options label-spacing">Mixture File*</label>
            <select
              name="bulkExpressionFile"
              value={
                `${formData.bulkExpressionFile.id}`
                  ? `${formData.bulkExpressionFile.id}|${formData.bulkExpressionFile.value}`
                  : ""
              }
              onChange={handleChange}
              className="form-select"
              required
            >
              <option value="" disabled>
                Select...
              </option>
              {bulkExpressionFile.map((file) => (
                <option key={file.id} value={`${file.id}|${file.name}`}>
                  {file.name}
                </option>
              ))}
              <option value="upload">Go to upload page to upload file.</option>

            </select>
            {errors.bulkExpressionFile && (
              <p className="error-text">{errors.bulkExpressionFile}</p>
            )}
          </div>

          <div className="form-group">
            <label className="menu-options label-spacing">Platform</label>
            <select
              name="platform"
              value={formData.platform}
              onChange={handleChange}
              className="form-select"
              required
            >
              <option value="none">RNA-Seq</option>
              <option value="apply">Microarray</option>
            </select>
          </div>

          <div className="form-group">
            <label className="menu-options label-spacing">Tokens*</label>
            <select
              name="token"
              value={
                `${formData.token.id}`
                  ? `${formData.token.id}|${formData.token.value}`
                  : ""
              }
              onChange={handleChange}
              className="form-select"
              required
            >
              <option value="" disabled>
                Select...
              </option>
              {tokens.length > 0 ? (
                tokens.map((token) => (
                  <option key={token.id} value={`${token.id}|${token.token}`}>
                    {token.token} {/* Display token value */}
                  </option>
                ))
              ) : (
                <option disabled>No tokens available</option>
              )}
            </select>
            {errors.token && <p className="error-text">{errors.token}</p>}
          </div>

          {/* </form> */}
        </div>
      </div>


      {isDesktop && (<hr />)}

        <div className="row">
          <div className="col-lg-3 mb-3">
            <span className="review-text sub-text">
              Name this run (optional) to find your results easily later
            </span>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
              <label className="menu-options label-spacing">Run Name</label>
              <input
                type="text"
                name="runName"
                value={formData.runName}
                onChange={handleChange}
                
              />
            </div>
          </div>
        </div>

      <hr />
    </>
  );
}
